import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
export default (function (context, inject) {
  var plugin = {
    /**
     * Check if the location has the required feature
     * @param {string} model - Name of the feature
     */
    get: function get(feature) {
      var active = context.$auth.active;
      var features = this.list;

      // Check if there is an active user and features are available
      if (!active || !features) {
        return false;
      }

      // Check if the user has the required model
      return features.includes(feature);
    },
    /**
     * Check if the location has all the required features in array
     * @param {array} featured - A list of features
     * @returns boolean
     */
    all: function all(features) {
      var _this = this;
      return features.every(function (feature) {
        return _this.get(feature);
      });
    },
    /**
     * Return the required features for a given path
     * @param {string} path - A path to check
     * @returns boolean
     */
    route: function route(path) {
      if (!path) {
        return false;
      }
      var resolved = context.app.router.resolve(path);
      var features = resolved && resolved.route ? resolved.route.meta.features : null;
      return features;
    },
    /**
     * Check if location has the required features for given path
     * @param {string} path - A path to check
     * @returns boolean
     */
    access: function access(path) {
      if (!path) {
        return false;
      }
      var resolved = context.app.router.resolve(path);
      var features = resolved && resolved.route ? resolved.route.meta.features : null;
      if (!features) {
        return true;
      }
      return this.all(features);
    },
    /**
     * Get a list of the locations features
     */
    get list() {
      var info = context.store.getters['auth/info'];
      return info.features;
    }
  };
  inject('features', plugin);
});